// public/js/components/ezViewManager.js

import { getAuth } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js';
import { getCachedNotificationPreferences } from '../modules/pushNotifications.js';
import { addFriend } from '../modules/firestore/firestoreService.js';


const tutorialContent = {};
let tutorialHistory = [];
let historyIndex = -1;


let activeNotifications = [];


let notificationQueue = [];
let isShowingNotification = false;


let lastShownMessage = null;


function shouldSuppressInAppForCategory(category) {
    if (!('Notification' in window) || Notification.permission !== 'granted') return false;
    const user = getAuth().currentUser;
    if (!user) return false;
    const prefs = getCachedNotificationPreferences();
    if (!prefs || !prefs.enabled) return false;
    return prefs.categories[category] === true;
}


function splitTextIntoParts(text, usableWidth, textElement) {
    const words = text.split(' ');
    const parts = [];
    let currentPart = '';
    
    for (let i = 0; i < words.length; i++) {
        const testPart = currentPart ? currentPart + ' ' + words[i] : words[i];
        textElement.textContent = testPart;
        textElement.style.display = 'inline-block';
        textElement.style.visibility = 'hidden';
        const testWidth = textElement.scrollWidth;
        textElement.style.display = '';
        textElement.style.visibility = '';
        
        if (testWidth <= usableWidth) {
            currentPart = testPart;
        } else {
            if (currentPart) {
                parts.push(currentPart);
                currentPart = words[i];
            } else {
                
                parts.push(words[i].substring(0, Math.floor(words[i].length * 0.5)) + '...');
                currentPart = '';
            }
        }
    }
    
    if (currentPart) {
        parts.push(currentPart);
    }
    
    
    if (parts.length > 3) {
        const firstTwo = parts.slice(0, 2);
        const rest = parts.slice(2).join(' ');
        firstTwo.push(rest.substring(0, Math.floor(rest.length * 0.7)) + '...');
        return firstTwo;
    }
    
    
    for (let i = 0; i < parts.length; i++) {
        textElement.textContent = parts[i];
        textElement.style.display = 'inline-block';
        textElement.style.visibility = 'hidden';
        const partWidth = textElement.scrollWidth;
        textElement.style.display = '';
        textElement.style.visibility = '';
        
        if (partWidth > usableWidth) {
            const truncateRatio = usableWidth / partWidth;
            parts[i] = parts[i].substring(0, Math.floor(parts[i].length * truncateRatio * 0.9)) + '...';
        }
    }
    
    return parts;
}


export function addNotification(message, options = {}) {
    const { type = 'info', id = null, duration = 3000, pushCategory = null } = options;

    if (pushCategory && shouldSuppressInAppForCategory(pushCategory)) {
        return id || `notif_${Date.now()}`;
    }

    
    const showNotifications = localStorage.getItem('showNotifications');
    if (showNotifications === 'false') {
        return id || `notif_${Date.now()}`;
    }

    
    
    if (lastShownMessage === message) {
        console.log('[Notifications] Skipping duplicate notification:', message.substring(0, 50) + '...');
        return id || `notif_${Date.now()}`;
    }

    
    notificationQueue.push({ message, type, id, duration });
    
    
    processNotificationQueue();
    
    return id || `notif_${Date.now()}`;
}


function processNotificationQueue() {
    if (isShowingNotification || notificationQueue.length === 0) {
        return;
    }
    
    isShowingNotification = true;
    
    
    const { message, type, id, duration } = notificationQueue.shift();
    
    
    const notifManager = document.getElementById('notifications-manager');
    
    if (!notifManager) {
        console.warn('[Notifications] Could not find notification manager');
        isShowingNotification = false;
        return;
    }

    
    const existingNotifications = notifManager.querySelectorAll('.notif-header-scrolling');
    existingNotifications.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(-10px)';
        setTimeout(() => {
            if (el.parentNode) el.parentNode.removeChild(el);
        }, 300);
    });

    
    const defaultStatus = document.getElementById('notif-default-status');
    if (defaultStatus) {
        defaultStatus.style.opacity = '0';
    }
    
    if (notifManager) {
        notifManager.classList.add('viewer-active');
    }

    
    let iconClass = 'fa-info-circle';
    let borderColor = '#3b82f6'; 
    if (type === 'success') {
        iconClass = 'fa-check-circle';
        borderColor = '#10b981'; 
    } else if (type === 'alert') {
        iconClass = 'fa-times-circle';
        borderColor = '#ef4444'; 
    }
    
    const messageId = id || `notif_${Date.now()}`;
    
    
    const scrollingText = document.createElement('div');
    scrollingText.id = messageId;
    scrollingText.className = 'notif-header-scrolling';
    scrollingText.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        font-size: 0.7em;
        font-weight: 700;
        color: #ffffff;
        z-index: 2;
        overflow: hidden;
        white-space: nowrap;
    `;
    
    scrollingText.innerHTML = `
        <span class="notif-scroll-wrapper" style="display: flex; align-items: center; gap: 6px; will-change: transform;">
            <i class="fas ${iconClass}" style="color: ${borderColor};"></i>
            <span class="notif-scroll-text" style="white-space: nowrap;">${message}</span>
        </span>
    `;

    
    notifManager.appendChild(scrollingText);
    
    
    activeNotifications.push(messageId);

    
    lastShownMessage = message;
    
    setTimeout(() => {
        if (lastShownMessage === message) {
            lastShownMessage = null;
        }
    }, 2000);

    
    const scrollWrapper = scrollingText.querySelector('.notif-scroll-wrapper');
    const scrollText = scrollingText.querySelector('.notif-scroll-text');
    if (scrollWrapper && scrollText) {
        
        scrollText.style.display = 'inline-block';
        scrollText.style.visibility = 'hidden';
        const textWidth = scrollText.scrollWidth;
        scrollText.style.display = '';
        scrollText.style.visibility = '';
        
        
        const containerWidth = notifManager.clientWidth;
        const usableWidth = containerWidth * 0.9;
        
        console.log('[EZView Notification] Text width:', textWidth, 'Usable width:', usableWidth, 'Will split:', textWidth > usableWidth);
        
        
        if (textWidth > usableWidth) {
            const parts = splitTextIntoParts(message, usableWidth, scrollText);
            console.log('[EZView Notification] Split into', parts.length, 'parts:', parts);
            
            
            let currentPartIndex = 0;
            const partDuration = ((duration > 0 ? duration : 5000) / parts.length) * 1.2;
            
            function displayPart(index) {
                if (index >= parts.length) return;
                scrollText.textContent = parts[index];
                currentPartIndex = index;
                
                
                if (index < parts.length - 1) {
                    setTimeout(() => displayPart(index + 1), partDuration);
                }
            }
            
            
            displayPart(0);
        } else {
            console.log('[EZView Notification] Text fits, no split needed');
        }
    }

    
    let dismissDelay = duration > 0 ? duration : 5000;
    let dismissTimeout = setTimeout(() => {
        dismissNotification(messageId, true); 
    }, dismissDelay);
}


function dismissNotification(notificationId, processQueue = false) {
    const messageEl = document.getElementById(notificationId);
    if (messageEl) {
        
        const scrollWrapper = messageEl.querySelector('.notif-scroll-wrapper');
        if (scrollWrapper) {
            const animation = scrollWrapper.getAnimations().find(a => a.id === 'marquee');
            if (animation) animation.cancel();
        }
        
        messageEl.style.opacity = '0';
        messageEl.style.transform = 'translateY(-10px)';
        setTimeout(() => {
            if (messageEl.parentNode) {
                messageEl.parentNode.removeChild(messageEl);
            }
            
            activeNotifications = activeNotifications.filter(id => id !== notificationId);
            
            
            if (processQueue) {
                isShowingNotification = false;
                processNotificationQueue();
            }
            
            
            if (!isShowingNotification && notificationQueue.length === 0) {
                const notifManager = document.getElementById('notifications-manager');
                if (notifManager) {
                    notifManager.classList.remove('viewer-active');
                }
                const defaultStatus = document.getElementById('notif-default-status');
                if (defaultStatus) {
                    defaultStatus.style.opacity = '1';
                    
                    import('../modules/notificationsManager.js').then(({ updateDefaultStatusBadge }) => {
                        updateDefaultStatusBadge();
                    }).catch(err => {
                        console.warn('[EZView] Could not call updateDefaultStatusBadge:', err);
                    });
                }
            }
        }, 300);
    }
}


export function removeNotification(notificationId) {
    dismissNotification(notificationId);
}

function switchEZView(viewToShow) {
    const notifBtn = document.getElementById('ez-view-notif-btn');
    const tutorialBtn = document.getElementById('ez-view-tutorial-btn');
    const notifPanel = document.getElementById('ez-view-notifications-panel');
    const tutorialPanel = document.getElementById('ez-view-tutorials-panel');

    if (!notifBtn || !tutorialBtn || !notifPanel || !tutorialPanel) return;

    notifBtn.classList.remove('active');
    tutorialBtn.classList.remove('active');
    notifPanel.classList.remove('active');
    tutorialPanel.classList.remove('active');

    if (viewToShow === 'notifications') {
        notifBtn.classList.add('active');
        notifPanel.classList.add('active');
        notifBtn.classList.remove('pulse-green', 'pulse-red');
    } else if (viewToShow === 'tutorials') {
        tutorialBtn.classList.add('active');
        tutorialPanel.classList.add('active');
    }

    localStorage.setItem('lastEZView', viewToShow);
}

function updateNavButtons() {
    const prevBtn = document.getElementById('tutorial-prev-btn');
    const nextBtn = document.getElementById('tutorial-next-btn');
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = historyIndex <= 0;
    nextBtn.disabled = historyIndex >= tutorialHistory.length - 1;
}

export function loadTutorial(tutorialId, direction = 'new') {
    if (tutorialId === tutorialHistory[historyIndex] && direction === 'new') return;
    const contentArea = document.getElementById('tutorial-content-area');
    const titleEl = document.getElementById('tutorial-title');
    if (!contentArea || !titleEl) return;
    const tutorial = tutorialContent[tutorialId];
    if (!tutorial) return;
    const placeholder = contentArea.querySelector('.ez-view-placeholder');
    if (placeholder) placeholder.remove();

    if (direction === 'new') {
        if (historyIndex < tutorialHistory.length - 1) {
            tutorialHistory = tutorialHistory.slice(0, historyIndex + 1);
        }
        if (tutorialHistory[historyIndex] !== tutorialId) {
            tutorialHistory.push(tutorialId);
            historyIndex = tutorialHistory.length - 1;
        }
    }

    updateNavButtons();
    titleEl.textContent = tutorial.title;

    const oldPages = contentArea.querySelectorAll('.tutorial-page');

    const newPage = document.createElement('div');
    newPage.className = 'tutorial-page';
    newPage.innerHTML = tutorial.content;
    let slideOutClass = 'slide-out-to-left';
    let slideInClass = 'slide-in-from-right';

    if (direction === 'prev') {
        slideOutClass = 'slide-out-to-right';
        slideInClass = 'slide-in-from-left';
    }

    if (oldPages.length > 0) {
        oldPages.forEach(oldPage => {
            oldPage.classList.add(slideOutClass);
            setTimeout(() => {
                oldPage.remove();
            }, 300); 
        });
    }
    
    newPage.classList.add(slideInClass);
    contentArea.appendChild(newPage);
}


export function triggerNotificationFlash(type) {
    const notifBtn = document.getElementById('ez-view-notif-btn');
    if (!notifBtn || notifBtn.classList.contains('active')) return;

    notifBtn.classList.remove('pulse-green', 'pulse-red');
    
    void notifBtn.offsetWidth; 

    if (type === 'success') {
        notifBtn.classList.add('pulse-green');
    } else if (type === 'alert') {
        notifBtn.classList.add('pulse-red');
    }
}

function setupTutorials() {
    const listStyle = `style="list-style: '• '; list-style-position: outside; padding-left: 1em;"`;
    tutorialContent['arm-controls'] = { title: 'A.R.M Playback Queue', content: `<ul ${listStyle}><li><b>Artist:</b> Plays all available songs by the current artist.</li><li><b>Random:</b> Plays a random shuffle of every song in the library.</li><li><b>My Playlists:</b> Opens a menu to select one of your custom playlists.</li></ul>` };
    tutorialContent['admin-panel'] = { title: 'Admin Panel', content: `An exclusive panel for users with administrator privileges which includes ...<ul style="list-style-type: '- '; padding-left: 1em;"><li>Chat banning.</li><li>Setting live Sonic Lounge shows.</li><li>Setting global color schemes.</li></ul>` };
    tutorialContent['show-modes'] = { title: 'Show Modes', content: `<ul ${listStyle}><li><b>Playlist:</b> A predetermined playlist.</li><li><b>Lottery:</b> Submit a ticket for a chance to have your song played.</li></ul>` };
    tutorialContent['profile-panel'] = { title: 'Profile Panel', content: `Where you upload your artist image/songs. This is also where these respective track/song descriptions and tags are filled.` };
    tutorialContent['search-panel'] = { title: 'Search Panel', content: `An interactive search system. Highlighted information represents your actual search words. Directly from this panel, you have the ability to...<ul ${listStyle}><li>Access and play any user's tracks.</li><li>Access and play the public playlists of that user.</li><li>See artist's images.</li><li>Related tags and track description for selected search item.</li><li>The selected user's biography.</li></ul>` };
    tutorialContent['playlist-panel'] = { title: 'Playlist Panel', content: `Add songs to your bucket from the play bar to create your customized playlist. You can...<ul ${listStyle}><li>Create a playlist (+).</li><li>Drag songs from the bucket and drop them in the selected playlist.</li><li>Add tags and a description.</li><li>Re-order.</li><li>Make it global/private.</li></ul>` };
    tutorialContent['music-panel'] = { title: 'Music Panel', content: `Shows information about the current song loaded. It contains...<ul ${listStyle}><li>Artist name.</li><li>Track description.</li><li>Comments.</li><li>Song art.</li><li>A.R.M. queue.</li></ul>` };
    tutorialContent['sonic-lounge-panel'] = { title: 'Sonic Lounge Panel', content: `When live, Sonic Lounge transforms into an interactive community experience with different show modes. It includes...<ul ${listStyle}><li>Playlist Shows (predetermined songs).</li><li>Lottery Shows with ticket system (randomly generated songs).</li><li>Chat (always open).</li></ul>` };
    tutorialContent['lottery-ticket'] = { title: 'Ticket', content: `Enter the lottery by clicking on the dice. Select up to 3 songs with drag and drop. Select the odds of which song will play should you win.` };
    tutorialContent['jukebot'] = { title: 'Jukebot', content: `Your AI assistant. You can ask it to change colors, fonts, or even help you schedule shows and upload songs.` };
    tutorialContent['mail'] = { title: 'Indie Chat', content: `Private messaging between artists. Use the icons in the chat bar to open threads.` };
    tutorialContent['settings'] = { title: 'Settings', content: `Placeholder text for settings.` };
    tutorialContent['socials'] = { title: 'Socials', content: `Shows basic artist information and their other socials. You can also play all their songs from this view. Can be accessed from your friend's list or by clicking on another user's pin.` };
    tutorialContent['customization-panel'] = { title: 'Customization', content: `Where you make the site your own with...<ul ${listStyle}><li>Font styles.</li><li>Color schemes.</li><li>Personal name banner.</li><li>Presets to save full styles.</li></ul>` };
    tutorialContent['customization-font'] = { title: 'Font', content: `Where you select a custom font for respective dropdown item. You can edit by...<ul ${listStyle}><li>Your name.</li><li>Titles.</li><li>Sections.</li><li>Edit your default.</li><li>Randomizer.</li></ul>` };
    tutorialContent['customization-banners'] = { title: 'Banners', content: `Select your personal banner image. You can...<ul ${listStyle}><li>Have a custom image.</li><li>Click 'none'.</li><li>Use stock images with randomizer.</li></ul>` };
    tutorialContent['customization-schemes'] = { title: 'Color Schemes', content: `A drag and drop system to colorize your selected dropdown menu item. You can...<ul ${listStyle}><li>Manually adjust with an RGB scale.</li><li>Randomize your colors.</li><li>Create groups of items to clone their colors, or alter them together.</li><li>Dissolve or remove an item from a group.</li></ul>` };
}

export function initializeEZView() {
    const notifBtn = document.getElementById('ez-view-notif-btn');
    const tutorialBtn = document.getElementById('ez-view-tutorial-btn');
    const prevBtn = document.getElementById('tutorial-prev-btn');
    const nextBtn = document.getElementById('tutorial-next-btn');
    
    
    const notifPanel = document.getElementById('ez-view-notifications-panel');
    if (notifPanel) {
        notifPanel.innerHTML = `<div class="ez-view-placeholder">Notifications appear in the Notifications panel.</div>`;
    }

    if (notifBtn) {
        notifBtn.addEventListener('click', () => switchEZView('notifications'));
    }
    if (tutorialBtn) {
        tutorialBtn.addEventListener('click', () => switchEZView('tutorials'));
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (historyIndex > 0) {
                historyIndex--;
                loadTutorial(tutorialHistory[historyIndex], 'prev');
            }
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (historyIndex < tutorialHistory.length - 1) {
                historyIndex++;
                loadTutorial(tutorialHistory[historyIndex], 'next');
            }
        });
    }
    
    setupTutorials();
    updateNavButtons();

    const savedView = localStorage.getItem('lastEZView') || 'tutorials';
    switchEZView(savedView);
}


function applyInlineMarquee(notificationItem, dismissDelay, updateDurationCallback) {
    const marqueeWrapper = notificationItem.querySelector('.notif-marquee-wrapper');
    const marqueeText = notificationItem.querySelector('.notif-marquee-text');
    if (!marqueeWrapper || !marqueeText) return;

    
    requestAnimationFrame(() => {
        setTimeout(() => {
            
            const existingAnim = marqueeWrapper.getAnimations().find(a => a.id === 'marquee');
            if (existingAnim) existingAnim.cancel();
            
            marqueeWrapper.classList.remove('marquee-scrolling');

            
            marqueeText.style.display = 'inline-block';
            marqueeText.style.visibility = 'hidden';
            marqueeText.style.whiteSpace = 'nowrap';
            
            const scrollWidth = marqueeWrapper.scrollWidth;
            const containerWidth = notificationItem.clientWidth - 24; 
            
            
            
            const startOffset = containerWidth;
            
            
            marqueeWrapper.style.transform = `translateX(${startOffset}px)`;
            
            
            marqueeText.style.display = '';
            marqueeText.style.visibility = '';
            
            console.log('[EZView] Marquee check:', { scrollWidth, containerWidth, startOffset, overflows: scrollWidth > containerWidth });
            
            
            const scrollSpeed = 75; 
            
            const scrollDistance = startOffset + scrollWidth;
            
            const calculatedDuration = (scrollDistance / scrollSpeed) * 1000;
            const animationDuration = Math.max(calculatedDuration, 3000); 
            
            marqueeWrapper.animate([
                { transform: `translateX(${startOffset}px)` }, 
                { transform: `translateX(-${scrollWidth}px)` } 
            ], {
                id: 'marquee',
                duration: animationDuration,
                iterations: 1, 
                easing: 'linear',
                fill: 'forwards'
            });
            
            const totalDuration = animationDuration;
            console.log('[EZView] Marquee applied, duration:', totalDuration + 'ms');
            
            if (updateDurationCallback) {
                updateDurationCallback(totalDuration);
            }
        }, 50);
    });
}


export function setupNotificationsExpandButton() {
    const expandBtn = document.getElementById('notif-expand-btn');
    const notifManager = document.getElementById('notifications-manager');
    const wrapper = document.getElementById('notifications-wrapper');
    const expandedContainer = document.getElementById('notif-expanded-container');
    
    if (!expandBtn || !notifManager || !wrapper || !expandedContainer) {
        setTimeout(setupNotificationsExpandButton, 500);
        return;
    }
    
    
    import('../modules/notificationsManager.js').then(({ updateExpandButtonBadge }) => {
        if (updateExpandButtonBadge) {
            updateExpandButtonBadge();
        }
    }).catch(e => {
        console.error('[EZView] Error setting initial expand button:', e);
    });
    
    expandBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isExpanded = wrapper.classList.contains('expanded');
        
        console.log('[EZView] Expand toggled, isExpanded:', isExpanded);
        console.log('[EZView] Wrapper classes:', wrapper.className);
        console.log('[EZView] Expanded container:', expandedContainer ? 'found' : 'not found');
        
        
        if (!isExpanded) {
            
            const copilotFeed = document.getElementById('copilot-feed');
            const loungeFeed = document.getElementById('lounge-chat-feed');
            
            const copilotScrollTop = copilotFeed ? copilotFeed.scrollTop : 0;
            const loungeScrollTop = loungeFeed ? loungeFeed.scrollTop : 0;
            
            
            let copilotWasAtBottom = false;
            let loungeWasAtBottom = false;
            
            if (copilotFeed) {
                const maxScroll = copilotFeed.scrollHeight - copilotFeed.clientHeight;
                copilotWasAtBottom = maxScroll > 0 && copilotScrollTop >= maxScroll - 5;
            }
            
            if (loungeFeed) {
                const maxScroll = loungeFeed.scrollHeight - loungeFeed.clientHeight;
                loungeWasAtBottom = maxScroll > 0 && loungeScrollTop >= maxScroll - 5;
            }
            
            console.log('[EZView] Captured scroll states before expand:', { 
                copilot: { scrollTop: copilotScrollTop, wasAtBottom: copilotWasAtBottom },
                lounge: { scrollTop: loungeScrollTop, wasAtBottom: loungeWasAtBottom }
            });
            
            
            renderExpandedNotifications(expandedContainer);
            
            
            void expandedContainer.offsetHeight;
            
            
            wrapper.classList.add('expanded');
            expandBtn.classList.add('expanded');
            
            document.getElementById('copilot-input-area')?.classList.add('notifications-expanded');
            
            
            const duration = 500; 
            const startTime = performance.now();
            
            function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                
                const easeProgress = progress < 0.5
                    ? 2 * progress * progress
                    : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                
                if (copilotFeed) {
                    const targetScroll = copilotWasAtBottom 
                        ? copilotFeed.scrollHeight 
                        : copilotScrollTop;
                    const startScroll = copilotWasAtBottom 
                        ? copilotScrollTop 
                        : copilotScrollTop;
                    const scrollDistance = targetScroll - startScroll;
                    copilotFeed.scrollTop = startScroll + scrollDistance * easeProgress;
                }
                
                if (loungeFeed) {
                    const targetScroll = loungeWasAtBottom 
                        ? loungeFeed.scrollHeight 
                        : loungeScrollTop;
                    const startScroll = loungeWasAtBottom 
                        ? loungeScrollTop 
                        : loungeScrollTop;
                    const scrollDistance = targetScroll - startScroll;
                    loungeFeed.scrollTop = startScroll + scrollDistance * easeProgress;
                }
                
                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                } else {
                    console.log('[EZView] Scroll animation complete');
                }
            }
            
            requestAnimationFrame(animateScroll);
        } else {
            
            const topPane = document.getElementById('chat-top-pane');
            const splitContainer = document.getElementById('chat-split-container');
            const copilotFeed = document.getElementById('copilot-feed');
            const loungeFeed = document.getElementById('lounge-chat-feed');
            let savedRatio = 0.75;
            
            if (topPane && splitContainer) {
                savedRatio = splitContainer.offsetHeight > 0 ? topPane.offsetHeight / splitContainer.offsetHeight : 0.75;
                console.log('[EZView] Saved ratio before collapse:', savedRatio);
            }
            
            
            const copilotScrollTop = copilotFeed ? copilotFeed.scrollTop : 0;
            const loungeScrollTop = loungeFeed ? loungeFeed.scrollTop : 0;
            
            
            let copilotWasAtBottom = false;
            let loungeWasAtBottom = false;
            
            if (copilotFeed) {
                const maxScroll = copilotFeed.scrollHeight - copilotFeed.clientHeight;
                copilotWasAtBottom = maxScroll > 0 && copilotScrollTop >= maxScroll - 5;
            }
            
            if (loungeFeed) {
                const maxScroll = loungeFeed.scrollHeight - loungeFeed.clientHeight;
                loungeWasAtBottom = maxScroll > 0 && loungeScrollTop >= maxScroll - 5;
            }
            
            console.log('[EZView] Captured scroll states before collapse:', { 
                copilot: { scrollTop: copilotScrollTop, wasAtBottom: copilotWasAtBottom },
                lounge: { scrollTop: loungeScrollTop, wasAtBottom: loungeWasAtBottom }
            });
            
            
            wrapper.classList.remove('expanded');
            expandBtn.classList.remove('expanded');
            
            document.getElementById('copilot-input-area')?.classList.remove('notifications-expanded');
            
            
            
            setTimeout(() => {
                expandedContainer.innerHTML = '';
            }, 300);
            
            
            setTimeout(() => {
                if (topPane && splitContainer) {
                    const currentMode = localStorage.getItem('jukebotTitleMode') || 'hybrid';
                    let newTopHeight;
                    
                    if (currentMode === 'chat') {
                        newTopHeight = 0;
                    } else if (currentMode === 'jukebot') {
                        const divider = document.getElementById('chat-divider');
                        if (!divider) return; // Divider removed
                        const dividerHeight = divider.offsetHeight;
                        newTopHeight = splitContainer.offsetHeight - dividerHeight;
                    } else {
                        const newContainerHeight = splitContainer.offsetHeight;
                        newTopHeight = newContainerHeight * savedRatio;
                    }
                    
                    topPane.style.height = `${newTopHeight}px`;
                    console.log('[EZView] Applied saved ratio after collapse. Mode:', currentMode, 'savedRatio:', savedRatio, 'newTopHeight:', newTopHeight);
                    
                    
                    requestAnimationFrame(() => {
                        if (copilotFeed) {
                            if (copilotWasAtBottom) {
                                copilotFeed.scrollTop = copilotFeed.scrollHeight;
                            } else {
                                copilotFeed.scrollTop = copilotScrollTop;
                            }
                        }
                        
                        if (loungeFeed) {
                            if (loungeWasAtBottom) {
                                loungeFeed.scrollTop = loungeFeed.scrollHeight;
                            } else {
                                loungeFeed.scrollTop = loungeScrollTop;
                            }
                        }
                        
                        console.log('[EZView] Restored scroll positions after collapse');
                    });
                    
                    
                    import('./consoleManager.js').then(module => {
                        if (module.saveSplitPosition) {
                            module.saveSplitPosition();
                        }
                    }).catch(err => {
                        console.warn('[EZView] Could not save split position:', err);
                    });
                }
            }, 350);
            
            return; 
        }
        
        
        setTimeout(() => {
            recalculateDividerPosition();
        }, 550);
    });
    
    console.log('[EZView] Notifications expand button initialized');
}


export function collapseNotificationsPanel() {
    const wrapper = document.getElementById('notifications-wrapper');
    const expandBtn = document.getElementById('notif-expand-btn');
    const expandedContainer = document.getElementById('notif-expanded-container');
    
    if (!wrapper || !expandBtn || !expandedContainer) return;
    
    const isExpanded = wrapper.classList.contains('expanded');
    if (!isExpanded) return;
    
    console.log('[EZView] Auto-collapsing notifications panel');
    
    
    const topPane = document.getElementById('chat-top-pane');
    const splitContainer = document.getElementById('chat-split-container');
    let savedRatio = 0.75;
    
    if (topPane && splitContainer) {
        savedRatio = splitContainer.offsetHeight > 0 ? topPane.offsetHeight / splitContainer.offsetHeight : 0.75;
        console.log('[EZView] Saved ratio before collapse:', savedRatio);
    }
    
    
    wrapper.classList.remove('expanded');
    expandBtn.classList.remove('expanded');
    
    document.getElementById('copilot-input-area')?.classList.remove('notifications-expanded');
    
    
    
    setTimeout(() => {
        expandedContainer.innerHTML = '';
    }, 300);
    
    
    setTimeout(() => {
        if (topPane && splitContainer) {
            const currentMode = localStorage.getItem('jukebotTitleMode') || 'hybrid';
            let newTopHeight;
            
            if (currentMode === 'chat') {
                newTopHeight = 0;
            } else if (currentMode === 'jukebot') {
                const divider = document.getElementById('chat-divider');
                if (!divider) return; // Divider removed
                const dividerHeight = divider.offsetHeight;
                newTopHeight = splitContainer.offsetHeight - dividerHeight;
            } else {
                const newContainerHeight = splitContainer.offsetHeight;
                newTopHeight = newContainerHeight * savedRatio;
            }
            
            topPane.style.height = `${newTopHeight}px`;
            console.log('[EZView] Applied saved ratio after collapse. Mode:', currentMode, 'savedRatio:', savedRatio, 'newTopHeight:', newTopHeight);
            
            
            import('./consoleManager.js').then(module => {
                if (module.saveSplitPosition) {
                    module.saveSplitPosition();
                }
            }).catch(err => {
                console.warn('[EZView] Could not save split position:', err);
            });
        }
    }, 350);
}


function recalculateDividerPosition() {
    const topPane = document.getElementById('chat-top-pane');
    const splitContainer = document.getElementById('chat-split-container');
    const divider = document.getElementById('chat-divider');
    
    if (!topPane || !divider || !splitContainer) return;
    
    
    const currentTopHeight = topPane.offsetHeight;
    const currentContainerHeight = splitContainer.offsetHeight;
    const currentRatio = currentContainerHeight > 0 ? currentTopHeight / currentContainerHeight : 0.75;
    
    console.log('[EZView] Before recalc - topHeight:', currentTopHeight, 'containerHeight:', currentContainerHeight, 'ratio:', currentRatio);
    
    
    void splitContainer.offsetHeight;
    
    
    const newContainerHeight = splitContainer.offsetHeight;
    
    
    const newTopHeight = newContainerHeight * currentRatio;
    topPane.style.height = `${newTopHeight}px`;
    
    console.log('[EZView] After recalc - newContainerHeight:', newContainerHeight, 'newTopHeight:', newTopHeight, 'maintained ratio:', currentRatio);
    
    
    import('./consoleManager.js').then(module => {
        if (module.saveSplitPosition) {
            module.saveSplitPosition();
        }
    }).catch(err => {
        console.warn('[EZView] Could not save split position:', err);
    });
}


export async function renderExpandedNotifications(expandedContainer) {
    
    const wrapper = document.getElementById('notifications-wrapper');
    
    
    expandedContainer.innerHTML = '';
    
    
    
    const expandedContent = document.createElement('div');
    expandedContent.className = 'notif-expanded-content';
    
    
    const sectionDefinitions = [
        { type: 'mentions', icon: 'fa-comments', label: 'Mentions', color: '#a78bfa' },
        { type: 'comments', icon: 'fa-comment', label: 'Comments', color: '#60a5fa' },
        { type: 'likes', icon: 'fa-heart', label: 'Likes', color: '#ef4444' },
        { type: 'coins', icon: 'fa-coins', label: 'Coins', color: '#fbbf24' }
    ];
    
    
    let notificationCounts = {
        coins: 0,
        likes: 0,
        comments: 0,
        mentions: 0
    };
    
    try {
        
        const moduleData = window.notificationsManagerModule;
        if (moduleData && moduleData.notificationsData) {
            const notifData = moduleData.notificationsData;
            
            
            Object.keys(notificationCounts).forEach(type => {
                const items = notifData[type] || [];
                
                notificationCounts[type] = items.length;
            });
            
            console.log('[EZView] Notification counts:', notificationCounts);
        } else {
            console.log('[EZView] notificationsManagerModule not available yet, trying import...');
            
            try {
                const notifModule = await import('../modules/notificationsManager.js');
                if (notifModule && notifModule.notificationsData) {
                    const notifData = notifModule.notificationsData;
                    
                    Object.keys(notificationCounts).forEach(type => {
                        const items = notifData[type] || [];
                        notificationCounts[type] = items.length;
                    });
                    
                    console.log('[EZView] Notification counts via import:', notificationCounts);
                }
            } catch (importErr) {
                console.log('[EZView] Could not import notificationsManager:', importErr);
            }
        }
    } catch (e) {
        console.log('[EZView] Error getting notification data:', e);
    }
    
    
    let sectionsHtml = sectionDefinitions.map(section => {
        const count = notificationCounts[section.type] || 0;
        return `
        <div class="notif-expanded-section" data-type="${section.type}" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0;
            background: rgba(0,0,0,0.3);
            border: 1px solid rgba(255,255,255,0.1);
            border-radius: 6px;
            margin-bottom: 6px;
        ">
            <div style="display: flex; align-items: center; gap: 8px; padding: 3px 10px;">
                <i class="fas ${section.icon}" style="color: ${section.color}; font-size: 0.8em;"></i>
                <span style="color: #ffffff; font-size: 0.7em; font-weight: 500;">${section.label}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 6px; padding: 3px 10px;">
                <span class="notif-section-count" style="background: rgba(255,255,255,0.15); padding: 2px 6px; border-radius: 4px; color: rgba(255,255,255,0.8); font-size: 0.6em;">${count}</span>
                <i class="fas fa-chevron-right" style="color: rgba(255,255,255,0.3); font-size: 0.5em;"></i>
            </div>
        </div>
    `;
    }).join('');
    
    
    
    expandedContent.innerHTML = sectionsHtml;
    
    
    expandedContent.querySelectorAll('.notif-expanded-section').forEach(sectionEl => {
        sectionEl.addEventListener('click', () => {
            const type = sectionEl.dataset.type;
            
            
            if (sectionEl.classList.contains('active')) {
                sectionEl.classList.remove('active');
                const existingBreakdown = expandedContent.querySelector('.notif-expanded-breakdown');
                if (existingBreakdown) {
                    existingBreakdown.remove();
                }
            } else {
                
                showSectionBreakdown(expandedContent, type);
            }
        });
    });
    
    
    const slideWrapper = document.createElement('div');
    slideWrapper.className = 'notif-expanded-slide-wrapper';
    slideWrapper.appendChild(expandedContent);
    expandedContainer.appendChild(slideWrapper);
    
    console.log('[EZView] Expanded content rendered, wrapper classes:', wrapper.className);
    console.log('[EZView] Slide wrapper:', slideWrapper ? 'created' : 'not created');
    console.log('[EZView] Expanded container children:', expandedContainer.children.length);
}


export async function showSectionBreakdown(expandedContent, type) {
    
    function formatDate(isoDate) {
        if (!isoDate) return '';
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    
    const existingBreakdown = expandedContent.querySelector('.notif-expanded-breakdown');
    if (existingBreakdown) {
        existingBreakdown.remove();
    }
    
    
    expandedContent.querySelectorAll('.notif-expanded-section').forEach(el => {
        el.classList.remove('active');
    });
    
    
    const sectionEl = expandedContent.querySelector(`[data-type="${type}"]`);
    if (!sectionEl) return;
    
    
    sectionEl.classList.add('active');
    
    
    let breakdownItems = [];
    
    try {
        if (window.notificationsManagerModule && window.notificationsManagerModule.notificationsData) {
            const notifData = window.notificationsManagerModule.notificationsData;
            const items = notifData[type] || [];
            
            
            
            if (type === 'coins') {
                breakdownItems = items; 
            } else {
                items.forEach(batch => {
                    if (batch.items) {
                        breakdownItems = breakdownItems.concat(batch.items);
                    }
                });
            }
        }
    } catch (e) {
        console.log('[EZView] Could not get breakdown data:', e);
    }
    
    
    const sectionColors = {
        coins: '#fbbf24',
        likes: '#ef4444',
        comments: '#60a5fa',
        mentions: '#a78bfa'
    };
    
    
    let breakdownHtml = '';
    if (breakdownItems.length === 0) {
        breakdownHtml = `
        <div class="notif-expanded-breakdown">
            <div style="color: rgba(255,255,255,0.5); font-size: 0.65em; text-align: center;">No notifications</div>
        </div>
        `;
    } else {
        
        let badgeState = null;
        if (type === 'coins') {
            try {
                const badgeStateModule = await import('../modules/badgeState.js');
                badgeState = badgeStateModule.badgeState;
                console.log('[EZView] badgeState loaded:', badgeState ? 'yes' : 'no', badgeState?.trophies ? Object.keys(badgeState.trophies).length + ' trophies' : 'no trophies');
            } catch (e) {
                console.log('[EZView] Could not load badgeState:', e);
            }
        }
        
        
        const BADGE_MILESTONE_SENTENCES = {
            
            'listen-5min': 'Earned {coins} coin for listening to 5 minutes of music.',
            'listen-15min': 'Earned {coins} coin for listening to 15 minutes of music.',
            'listen-30min': 'Earned {coins} coin for listening to 30 minutes of music.',
            'leave-comment-1': 'Earned {coins} coin for leaving your first comment.',
            'leave-comment-2': 'Earned {coins} coin for leaving 2 comments.',
            'leave-comment-3': 'Earned {coins} coin for leaving 3 comments.',
            'leave-message-1': 'Earned {coins} coin for sending your first message in the global chat.',
            'leave-message-2': 'Earned {coins} coin for sending 2 messages in the global chat.',
            'leave-message-3': 'Earned {coins} coin for sending 3 messages in the global chat.',
            'daily-like-1': 'Earned {coins} coin for liking 1 song.',
            'daily-like-2': 'Earned {coins} coin for liking 2 different songs.',
            'daily-like-3': 'Earned {coins} coin for liking 3 different songs.',
            'daily-liked-1': 'Earned {coins} coin for getting a like on your song.',
            'daily-liked-2': 'Earned {coins} coin for getting likes on 2 different songs.',
            'daily-liked-3': 'Earned {coins} coin for getting likes on 3 different songs.',
            
            'name': 'Earned {coins} coins for setting your artist name.',
            'logo': 'Earned {coins} coins for uploading your profile picture.',
            'bio': 'Earned {coins} coins for writing your bio.',
            'personality': 'Earned {coins} coins for setting your AI personality.',
            'social-1': 'Earned {coins} coin for connecting your first social link.',
            'social-2': 'Earned {coins} coin for connecting 2 social links.',
            'social-3': 'Earned {coins} coin for connecting 3 social links.',
            'social-4': 'Earned {coins} coin for connecting 4 social links.',
            'social-5': 'Earned {coins} coin for connecting 5 social links.',
            'use-help-mode': 'Earned {coins} coin for using help mode.',
            'deploy-command': 'Earned {coins} coin for deploying a command.',
            'create-theme': 'Earned {coins} coin for creating a new theme.',
            'send-dm': 'Earned {coins} coin for sending a direct message.',
            'run-search': 'Earned {coins} coin for running a search.',
            'song-1': 'Earned {coins} coins for uploading your first song.',
            'song-2': 'Earned {coins} coins for uploading 2 songs.',
            'song-3': 'Earned {coins} coins for uploading 3 songs.',
            'song-4': 'Earned {coins} coins for uploading 4 songs.',
            'song-5': 'Earned {coins} coins for uploading 5 songs.',
            'song-6': 'Earned {coins} coins for uploading 6 songs.',
            'song-7': 'Earned {coins} coins for uploading 7 songs.',
            'song-8': 'Earned {coins} coins for uploading 8 songs.',
            'song-9': 'Earned {coins} coins for uploading 9 songs.',
            'song-10': 'Earned {coins} coins for uploading 10 songs.',
            'song-11': 'Earned {coins} coins for uploading 11 songs.',
            'song-12': 'Earned {coins} coins for uploading 12 songs.',
            'song-13': 'Earned {coins} coins for uploading 13 songs.',
            'song-14': 'Earned {coins} coins for uploading 14 songs.',
            'song-15': 'Earned {coins} coins for uploading 15 songs.',
            'chat-10': 'Earned {coins} coin for sending 10 messages in the global chat.',
            'chat-25': 'Earned {coins} coins for sending 25 messages in the global chat.',
            'chat-50': 'Earned {coins} coins for sending 50 messages in the global chat.',
            'chat-75': 'Earned {coins} coins for sending 75 messages in the global chat.',
            'chat-100': 'Earned {coins} coins for sending 100+ messages in the global chat.',
            'playlist-1': 'Earned {coins} coin for building a playlist with 1 song.',
            'playlist-2': 'Earned {coins} coins for building a playlist with 2 songs.',
            'playlist-3': 'Earned {coins} coins for building a playlist with 3 songs.',
            'playlist-4': 'Earned {coins} coins for building a playlist with 4 songs.',
            'playlist-5': 'Earned {coins} coins for building a playlist with 5 songs.',
            'playlist-add-1': 'Earned {coins} coin for getting your song added to someone\'s playlist.',
            'playlist-add-2': 'Earned {coins} coin for getting 2 songs added to playlists.',
            'playlist-add-3': 'Earned {coins} coin for getting 3 songs added to playlists.',
            'playlist-add-4': 'Earned {coins} coin for getting 4 songs added to playlists.',
            'playlist-add-5': 'Earned {coins} coin for getting 5 songs added to playlists.',
            'win-1': 'Earned {coins} coins for winning the daily lottery show.',
            'win-10': 'Earned {coins} coins for winning 10 lottery shows.',
            'win-25': 'Earned {coins} coins for winning 25 lottery shows.'
        };
        
        
        const BADGE_TROPHY_SENTENCES = {
            'vibe-check': "Earned {coins} coins towards the 'Vibe Check' badge",
            'critic': "Earned {coins} coins towards the 'Critic' badge",
            'social-butterfly': "Earned {coins} coins towards the 'Social Butterfly' badge",
            'appreciator': "Earned {coins} coins towards the 'Appreciator' badge",
            'crowd-pleaser': "Earned {coins} coins towards the 'Crowd Pleaser' badge",
            'profile': "Earned {coins} coins towards the 'Profile' badge",
            'network': "Earned {coins} coins towards the 'Network' badge",
            'upload-star': "Earned {coins} coins towards the 'Upload Star' badge",
            'chatterbox': "Earned {coins} coins towards the 'Chatterbox' badge",
            'playlist-boss': "Earned {coins} coins towards the 'Playlist Boss' badge",
            'playlist-curator': "Earned {coins} coins towards the 'Playlist Curator' badge",
            'lucky-star': "Earned {coins} coins towards the 'Lucky Star' badge",
            'daily-winner': "Earned {coins} coins towards the 'Daily Winner' badge",
            'feedback': "Earned {coins} coins for leaving feedback"
        };
        
        breakdownHtml = breakdownItems.map(item => {
            
            let content = '';
            let amountDisplay = '';
            
            if (type === 'coins') {
                
                const badgeId = item.badgeId;
                console.log('[EZView] Processing coin notification item:', { badgeId, item });
                
                
                let displaySource = '';
                const badgeName = item.badgeName || item.items?.[0]?.badgeName;
                if (badgeName) {
                    displaySource = badgeName;
                } else if (badgeId && BADGE_MILESTONE_SENTENCES[badgeId]) {
                    displaySource = BADGE_MILESTONE_SENTENCES[badgeId];
                } else {
                    displaySource = item.source || 'Achievement';
                    
                    
                    displaySource = displaySource.replace(/\s*\+\d+\s*coins.*/gi, '').trim();
                    displaySource = displaySource.replace(/\.\s*$/, '').trim();
                    
                    
                    if (displaySource.length < 50 && !displaySource.startsWith('Earned')) {
                        const trophySentence = BADGE_TROPHY_SENTENCES[displaySource];
                        if (trophySentence) {
                            displaySource = trophySentence;
                        }
                    }
                }
                
                const totalCoins = item.totalAmount || item.amount || 0;
                
                
                displaySource = displaySource.replace('{coins}', totalCoins);
                if (totalCoins === 1) {
                    displaySource = displaySource.replace(/\bcoins\b/g, 'coin');
                } else {
                    displaySource = displaySource.replace(/\bcoin\b/g, 'coins');
                }
                
                
                const firstDate = item.firstAchievedDate ? formatDate(item.firstAchievedDate) : '';
                const lastDate = item.lastAchievedDate ? formatDate(item.lastAchievedDate) : '';
                const dateSpan = firstDate && lastDate && firstDate !== lastDate 
                    ? ` (${firstDate} - ${lastDate})` 
                    : firstDate ? ` (${firstDate})` : '';
                
                displaySource = displaySource.replace(/\.$/, '') + dateSpan;
                
                content = `<span style="color: #ffffff; font-size: 0.65em;"><strong>${displaySource}</strong></span>`;
                
                amountDisplay = '';
            } else if (type === 'mentions') {
                
                const sender = item.from || item.source || 'Someone';
                
                if (item.isContactAdd) {
                    const itemDate = item.timestamp ? formatDate(item.timestamp) : '';
                    const dateSpan = itemDate ? ` (${itemDate})` : '';
                    content = `<span style="color: #ffffff; font-size: 0.65em;">${sender} has added you to his contacts.${dateSpan}</span>`;
                } else {
                    let message = (item.preview || '').replace(/@[\w]+/g, '').trim();
                    
                    message = message.replace(/↳\s*\w+/g, '').trim();
                    const isReply = item.isReply || false;
                    const action = isReply ? 'replied' : 'says';
                    
                    const itemDate = item.timestamp ? formatDate(item.timestamp) : '';
                    const dateSpan = itemDate ? ` (${itemDate})` : '';
                    
                    content = `<span style="color: #ffffff; font-size: 0.65em;">${sender} ${action} '${message}'${dateSpan}</span>`;
                }
            } else if (type === 'comments') {
                
                const commenter = item.from || item.source || 'Someone';
                const commentPreview = item.preview || '';
                const songTitle = item.source || item.songTitle || 'your song';
                
                const itemDate = item.timestamp ? formatDate(item.timestamp) : '';
                const dateSpan = itemDate ? ` (${itemDate})` : '';
                
                content = `<span style="color: #ffffff; font-size: 0.65em;">${commenter} commented '${commentPreview}' on <strong>${songTitle}</strong>${dateSpan}</span>`;
            } else if (type === 'likes') {
                
                const liker = item.from || item.source || 'Someone';
                const songTitle = item.source || item.songTitle || 'your song';
                
                const itemDate = item.timestamp ? formatDate(item.timestamp) : '';
                const dateSpan = itemDate ? ` (${itemDate})` : '';
                
                content = `<span style="color: #ffffff; font-size: 0.65em;">${liker} liked '${songTitle}'${dateSpan}</span>`;
            } else {
                
                const itemDate = item.timestamp ? formatDate(item.timestamp) : '';
                const dateSpan = itemDate ? ` (${itemDate})` : '';
                content = `<span style="color: #ffffff; font-size: 0.65em;">${item.source || 'Notification'}${dateSpan}</span>`;
            }
            
            if (type === 'coins') {
                return `
                <div class="notif-expanded-breakdown-item" style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 8px 8px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                ">
                    <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                        ${content}
                    </div>
                </div>
                `;
            }
            
            return `
            <div class="notif-expanded-breakdown-item" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 8px 8px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            ">
                <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                    ${content}
                </div>
                <div style="display: flex; align-items: center; gap: 6px;">
                    ${amountDisplay || (item.amount ? `<span style="color: ${sectionColors[type] || '#a78bfa'}; font-size: 0.65em; font-weight: 600;">+${item.amount}</span>` : '')}
                </div>
            </div>
            `;
        }).join('');
        
        breakdownHtml = `
        <div class="notif-expanded-breakdown">
            <div class="notif-clear-banner" data-type="${type}">
                <span style="color: rgba(255,255,255,0.6); font-size: 0.6em; text-transform: uppercase; letter-spacing: 0.5px;">Clear All</span>
            </div>
            ${breakdownHtml}
        </div>
        `;
    }
    
    
    sectionEl.insertAdjacentHTML('afterend', breakdownHtml);
    
    
    const clearBanner = expandedContent.querySelector('.notif-clear-banner');
    if (clearBanner) {
        clearBanner.addEventListener('click', async () => {
            const clearType = clearBanner.dataset.type;
            
            
            const breakdown = expandedContent.querySelector('.notif-expanded-breakdown');
            if (breakdown) {
                breakdown.innerHTML = `<div style="color: rgba(255,255,255,0.5); font-size: 0.65em; text-align: center; padding: 15px 0;">No notifications</div>`;
            }
            
            
            const countBadge = sectionEl.querySelector('.notif-section-count');
            if (countBadge) {
                countBadge.textContent = '0';
            }
            
            
            await clearNotificationsByType(clearType);
            
            
            showClearedIndicator();
        });
    }
}


async function clearNotificationsByType(type) {
    try {
        const { clearNotificationsByType: clearType } = await import('../modules/notificationsManager.js');
        await clearType(type);
        console.log(`[EZView] Cleared all ${type} notifications`);
    } catch (e) {
        console.error('[EZView] Error clearing notifications:', e);
    }
}


async function showClearedIndicator() {
    const expandBtn = document.getElementById('notif-expand-btn');
    if (!expandBtn) return;
    
    
    const originalIcon = expandBtn.innerHTML;
    expandBtn.innerHTML = '<i class="fas fa-check"></i>';
    expandBtn.style.color = '#34d399';
    
    
    setTimeout(async () => {
        try {
            const { updateExpandButtonBadge } = await import('../modules/notificationsManager.js');
            if (updateExpandButtonBadge) {
                updateExpandButtonBadge();
            }
        } catch (e) {
            console.error('[EZView] Error restoring expand button:', e);
            
            expandBtn.innerHTML = originalIcon;
        }
        expandBtn.style.color = '';
    }, 1500);
}


export function setupNotificationsBanner() {
    const banner = document.getElementById('notifications-banner');
    const expandBtn = document.getElementById('notif-expand-btn');
    
    if (!banner) {
        setTimeout(setupNotificationsBanner, 500);
        return;
    }
    
    
    banner.addEventListener('click', async (e) => {
        
        if (expandBtn) {
            expandBtn.click();
        }
        
        
        try {
            const { handleProfileClick } = await import('./chatBannerManager.js');
            if (handleProfileClick) {
                await handleProfileClick();
            }
        } catch (err) {
            console.error('[EZView] Error opening artist card:', err);
        }
    });
    
    console.log('[EZView] Notifications banner initialized');
}


export function setupNotificationsHoverSync() {
    const banner = document.getElementById('notifications-banner');
    const notifManager = document.getElementById('notifications-manager');
    const expandBtn = document.getElementById('notif-expand-btn');
    
    if (!banner || !notifManager) {
        console.log('[EZView] Hover sync: waiting for elements...');
        setTimeout(setupNotificationsHoverSync, 500);
        return;
    }
    
    console.log('[EZView] Setting up hover sync with expandBtn:', expandBtn ? 'found' : 'not found');
    
    
    banner.addEventListener('mouseenter', () => {
        notifManager.classList.add('hover-sync-active');
        banner.classList.add('hover-sync-active'); 
    });
    
    banner.addEventListener('mouseleave', () => {
        notifManager.classList.remove('hover-sync-active');
        banner.classList.remove('hover-sync-active'); 
    });
    
    
    notifManager.addEventListener('mouseenter', () => {
        banner.classList.add('hover-sync-active');
    });
    
    notifManager.addEventListener('mouseleave', () => {
        banner.classList.remove('hover-sync-active');
    });
    
    
    
    console.log('[EZView] Notifications hover sync initialized');

    
    document.addEventListener('requestNotificationsExpand', () => {
        const wrapper = document.getElementById('notifications-wrapper');
        const expandedContainer = document.getElementById('notif-expanded-container');
        if (!wrapper) return;
        const isExpanded = wrapper.classList.toggle('expanded');
        if (isExpanded && expandedContainer) {
            renderExpandedNotifications(expandedContainer);
            document.getElementById('copilot-input-area')?.classList.add('notifications-expanded');
        } else if (expandedContainer) {
            setTimeout(() => { expandedContainer.innerHTML = ''; }, 300);
            document.getElementById('copilot-input-area')?.classList.remove('notifications-expanded');
        }
    });
}

setTimeout(setupNotificationsExpandButton, 500);
setTimeout(setupNotificationsBanner, 500);
setTimeout(setupNotificationsHoverSync, 500);
